import { IClientTicketPoint, IClientTripFullPoint } from '@bustickus/models-client';
import * as bi from 'react-bootstrap-icons';
import { Flex } from 'components';
import { Icon } from 'shared/components';
import { dateFormat } from 'common/helpers';
import './style.scss';

interface IProps {
  type: 'arrival' | 'departure';
  point: IClientTicketPoint;
}

function CityData(props: IProps) {
  const date = dateFormat(
    props.type === 'departure' ? props.point.departureDate : props.point.arrivalDate,
    'DD MMMM YYYY HH:mm'
  );

  return (
    <Flex
      gap={5}
      className='t-city-JeiA'
    >
      <div>
        <Icon color='red'>
          <bi.Signpost />
        </Icon>
      </div>
      <Flex direction='column'>
        <span>
          <b>{props.type === 'departure' ? 'Отправление' : 'Прибытие'}</b>
        </span>
        <span>
          {props.point.cityName}
          <span className='country-dphr'>, {props.point.countryName}</span>
        </span>
        <span className='date-wy3Y'>
          {date.datetime} <span className='tz-pFWs'>({date.mskTimezone})</span>
        </span>
        {props.point.address != null && <span className='address-8Cwv'>{props.point.address}</span>}
      </Flex>
    </Flex>
  );
}

export default CityData;
